export const getMediaUploadPermissionUrl = (formId: string, returnCreateIssueAdf: boolean) =>
	`/rest/api/2/attachment/upload/form/${formId}/credentials?returnCreateIssueAdf=${returnCreateIssueAdf}`;

export const getFormAttachmentUploadUrl = (formId: string) =>
	`/rest/api/2/attachment/upload/form/${formId}`;
